@if (deviceService.isMobile && userService.isAuthenticated) {
    @if (!isDataLoaded) {
        <div class="toggle-loader">
            <div class="loader"></div>
        </div>
    } @else {
        <div class="toggle-navigation">
            <ds-segmented-control
                class="ds-segment-full-width"
                [twoLineTruncation]="false"
                [fullWidth]="true"
                [inverse]="true"
                [roleType]="'tablist'"
                [activeOption]="toggleNavigationService.isPromoActive ? 'offers' : 'rewards'"
                (activeOptionChange)="onToggleNavigation($event)">
                <ds-segmented-option name="offers" [title]="rewardsHubSegments?.promoHub" />
                <ds-segmented-option name="rewards" [title]="rewardsHubSegments?.rewardsHub" />
            </ds-segmented-control>
            @if (!isTooltipClosed && this.rewardsHubConfiguration?.enableRewardsHubNotification) {
                <div
                    #tooltipContainer
                    [dsTooltipTriggerFor]="tooltipTemplate"
                    dsTooltipOnFocus
                    position="bottom"
                    arrowPosition="middle"
                    [autoOpen]="true"
                    [autoCloseTime]="0"
                    [tooltipToggle]="false"
                    [fullWidth]="false"
                    [tooltipCustomClass]="'toogle-tooltip'">
                    <ng-template #tooltipTemplate>
                        <ds-tooltip-content variant="utility" inverse="false" [fullWidth]="false">
                            <vn-icon name="theme-close-small" slot="close" (click)="closeInfoTooltip()" size="9"></vn-icon>

                            <div slot="title" class="info-tooltip-title">{{ rewardsHubSegments?.toolTipTitle }}</div>

                            <div slot="description" class="info-tooltip-description">{{ rewardsHubSegments?.toolTipDescription }}</div>
                        </ds-tooltip-content>
                    </ng-template>
                </div>
            }
        </div>
    }
}
